<template>
    <div class="about">
        <!-- ===== Banner ===== -->
        <section class="hero" :style="{ backgroundImage: `url(${heroUrl})` }">
            <div class="hero-mask"></div>
            <div class="hero-title">关于技明电器</div>
        </section>

        <!-- ===== 入口导航（截图里 4 个图标块） ===== -->
        <section class="quick">
            <div class="container">
                <div class="quick-grid">
                    <button class="q-item" type="button" @click="scrollTo('sec-about')">
                        <span class="q-ico">◎</span>
                        <span class="q-txt">关于技明</span>
                    </button>
                    <button class="q-item" type="button" @click="scrollTo('sec-adv')">
                        <span class="q-ico">♛</span>
                        <span class="q-txt">技明优势</span>
                    </button>
                    <!-- <button class="q-item" type="button" @click="scrollTo('sec-honor')">
                        <span class="q-ico">▦</span>
                        <span class="q-txt">荣誉资质</span>
                    </button> -->
                    <button class="q-item" type="button" @click="scrollTo('sec-contact')">
                        <span class="q-ico">✉</span>
                        <span class="q-txt">联系技明</span>
                    </button>
                </div>
            </div>
        </section>

        <!-- ===== 关于技明电器（段落） ===== -->
        <section class="sec" id="sec-about">
            <div class="container">
                <div class="para">
                    余姚市技明电器有限公司成立于 2009 年 10 月，是一家扎根 “中国五金制品生产基地” 余姚，专注多品类制造与全球贸易的实力企业。公司坐落于余姚市凤山街道永丰村冯严 34
                    号，依托当地完善的家电、五金产业链配套优势，深耕电气机械和器材制造领域，历经十余年稳健发展，已形成成熟的生产运营体系。
                </div>
                <div class="para">
                    公司聚焦四大核心品类的制造与加工，产品覆盖家用电器、照明灯具、塑料制品及五金件，可满足客户多元化定制与规模化生产需求。凭借余姚本地 “常规配件当天采购、当天到货”
                    的产业优势，实现从原材料采购到成品交付的高效衔接，为各类合作提供坚实供应保障
                </div>
                <div class="para">
                    公司具备自营和代理货物及技术进出口资质，可承接全球贸易订单，产品远销多个国家和地区，不受国家限定经营或禁止进出口的货物和技术范围限制。
                </div>
            </div>
        </section>

        <!-- ===== 技明优势（4 卡片 2x2） ===== -->
        <section class="sec alt" id="sec-adv">
            <div class="container">
                <div class="adv-grid">
                    <div class="adv-card">
                        <div class="adv-ico blue">◆</div>
                        <div class="adv-hd">专注</div>
                        <div class="adv-desc">十余年深耕多品类制造与加工，形成成熟稳定的生产运营体系，覆盖客户多元化需求。</div>
                    </div>
                    <div class="adv-card">
                        <div class="adv-ico orange">▣</div>
                        <div class="adv-hd">可靠</div>
                        <div class="adv-desc">从原料到成品严格把控品质，建立规范的生产与品控流程，确保交付稳定可靠。</div>
                    </div>
                    <div class="adv-card">
                        <div class="adv-ico cyan">⌁</div>
                        <div class="adv-hd">技术</div>
                        <div class="adv-desc">持续投入工艺与设备升级，支持多元化、定制化生产，让每一件产品都经得起检验。</div>
                    </div>
                    <div class="adv-card">
                        <div class="adv-ico green">✓</div>
                        <div class="adv-hd">服务</div>
                        <div class="adv-desc">从打样、生产到交付全流程跟进，提供高效贴心的合作支持，与海内外客户携手共赢。</div>
                    </div>
                </div>
            </div>
        </section>

        <!-- ===== 发展历程（时间轴 + hover 移动动画） ===== -->
        <section class="sec" id="sec-timeline">
            <div class="container">
                <h2 class="sec-title">发展历程</h2>

                <div class="timeline" ref="timelineRef">
                    <!-- 中间竖线 -->
                    <div class="t-line"></div>

                    <!-- ✅ 活动点：hover 不同年份时平滑移动 -->
                    <div class="t-active-dot" :style="{ top: activeDotTop + 'px' }"></div>

                    <div v-for="(it, i) in timeline" :key="it.year" class="t-row"
                        :class="{ left: i % 2 === 0, right: i % 2 === 1, active: activeIndex === i }"
                        @mouseenter="setActive(i)">
                        <!-- 左侧内容 -->
                        <div class="t-side">
                            <template v-if="i % 2 === 0">
                                <div class="t-year">{{ it.year }}年</div>
                                <div class="t-card">
                                    <div v-for="(line, k) in it.lines" :key="k" class="t-text">{{ line }}</div>
                                </div>
                            </template>
                        </div>

                        <!-- 中间点（用于计算 activeDot 位置） -->
                        <div class="t-mid">
                            <span class="t-dot" :ref="(el) => setDotRef(el, i)"></span>
                        </div>

                        <!-- 右侧内容 -->
                        <div class="t-side">
                            <template v-if="i % 2 === 1">
                                <div class="t-year">{{ it.year }}年</div>
                                <div class="t-card">
                                    <div v-for="(line, k) in it.lines" :key="k" class="t-text">{{ line }}</div>
                                </div>
                            </template>
                        </div>
                    </div>
                </div>

            </div>
        </section>

        <!-- ===== 荣誉资质（占位） ===== -->
        <!-- <section class="sec alt" id="sec-honor">
            <div class="container">
                <h2 class="sec-title">荣誉资质</h2>
                <div class="placeholder">图片展示位置</div>
            </div>
        </section> -->

        <!-- ===== 联系技明电器 ===== -->
        <section class="sec" id="sec-contact">
            <div class="container">
                <h2 class="sec-title">联系技明电器</h2>
                <div class="contact">
                    <div class="c-item"><span class="c-k">咨询热线：</span><span class="c-v">13958349372</span></div>
                    <div class="c-item"><span class="c-k">业务邮箱：</span><span class="c-v">17371988805@163.com</span></div>
                    <div class="c-item">
                        <span class="c-k">公司地址：</span>
                        <span class="c-v">余姚市凤山街道永丰村冯严34号</span>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script setup>
import { nextTick, onBeforeUnmount, onMounted, ref } from "vue";

const heroUrl = require("../static/2.webp");

function scrollTo(id) {
    const el = document.getElementById(id);
    if (!el) return;
    el.scrollIntoView({ behavior: "smooth", block: "start" });
}

/** ===== 时间轴数据 ===== */
const timeline = [
    { year: 2023, lines: ["持续优化生产管理与品质体系", "进出口业务稳步推进，服务更多海外客户"] },
    { year: 2021, lines: ["强化外贸合作渠道", "四大品类协同制造能力进一步完善"] },
    { year: 2018, lines: ["扩充产品线与产能", "形成家电、照明、塑料、五金多品类布局"] },
    { year: 2015, lines: ["拓展多元客户合作", "支持 OEM / ODM 定制生产模式"] },
    { year: 2012, lines: ["完善生产工艺流程", "提升稳定量产与品质管控能力"] },
    { year: 2009, lines: ["公司于余姚正式成立", "专注电器制造与加工业务"] },
];

/** ===== hover 移动动画关键：activeDot 根据 dot 的位置平滑移动 ===== */
const timelineRef = ref(null);
const dotRefs = ref([]); // 保存每个年份的 dot DOM
const activeIndex = ref(0);
const activeDotTop = ref(12);

function setDotRef(el, i) {
    if (el) dotRefs.value[i] = el;
}

function setActive(i) {
    activeIndex.value = i;
    nextTick(updateActiveDot);
}

function updateActiveDot() {
    const wrap = timelineRef.value;
    const dot = dotRefs.value[activeIndex.value];
    if (!wrap || !dot) return;

    const wrapRect = wrap.getBoundingClientRect();
    const dotRect = dot.getBoundingClientRect();

    // 让活动点居中对齐 dot
    const top = dotRect.top - wrapRect.top + dotRect.height / 2 - 7; // 7 = activeDot 半径
    activeDotTop.value = Math.max(0, top);
}

function onResize() {
    updateActiveDot();
}

onMounted(async () => {
    await nextTick();
    updateActiveDot();
    window.addEventListener("resize", onResize, { passive: true });
});

onBeforeUnmount(() => {
    window.removeEventListener("resize", onResize);
});
</script>

<style scoped>
.about {
    background: #fff;
}

/* ===== Banner ===== */
.hero {
    position: relative;
    height: 380px;
    background-size: cover;
    background-position: center;
}

.hero-mask {
    position: absolute;
    inset: 0;
    background: linear-gradient(to bottom, rgba(6, 38, 78, 0.45), rgba(6, 38, 78, 0.55));
}

.hero-title {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    color: #fff;
    font-size: 42px;
    font-weight: 800;
    letter-spacing: 4px;
    text-shadow: 0 4px 20px rgba(0, 0, 0, 0.35);
}

@media (max-width: 640px) {
    .hero-title {
        font-size: 28px;
    }
}

/* ===== container ===== */
.container {
    width: 100%;
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 18px;
}

/* ===== quick nav ===== */
.quick {
    background: #f3f3f3;
}

.quick-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 0;
}

.q-item {
    padding: 34px 10px;
    border: none;
    background: transparent;
    cursor: pointer;
    display: grid;
    place-items: center;
    gap: 14px;
    color: #666;
}

.q-item:hover {
    background: #efefef;
}

.q-ico {
    font-size: 22px;
    color: #9a9a9a;
}

.q-txt {
    font-size: 16px;
}

/* ===== sections ===== */
.sec {
    padding: 62px 0;
}

.sec.alt {
    background: #f7f7f7;
}

.sec-title {
    margin: 0 0 28px;
    text-align: center;
    font-size: 34px;
    font-weight: 800;
    color: #333;
}

.para {
    color: #666;
    line-height: 2.2;
    font-size: 16px;
    text-align: center;
    margin: 18px auto 0;
    max-width: 980px;
}

/* ===== adv cards ===== */
.adv-grid {
    margin-top: 38px;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 26px;
}

.adv-card {
    background: #eef0f3;
    border-radius: 6px;
    padding: 26px 26px;
    display: grid;
    grid-template-columns: 76px 1fr;
    column-gap: 18px;
    align-items: center;
}

.adv-ico {
    width: 62px;
    height: 62px;
    border-radius: 999px;
    display: grid;
    place-items: center;
    font-size: 20px;
    background: #fff;
    border: 2px solid #dfe5ee;
    color: #2b6cb0;
}

.adv-ico.orange {
    color: #e07a25;
}

.adv-ico.cyan {
    color: #2b9db3;
}

.adv-ico.green {
    color: #2f855a;
}

.adv-hd {
    font-size: 26px;
    font-weight: 800;
    color: #333;
    margin-bottom: 6px;
}

.adv-desc {
    grid-column: 2 / 3;
    color: #666;
    line-height: 1.9;
    font-size: 14px;
    margin-top: 6px;
}

/* ===== timeline ===== */
.timeline {
    position: relative;
    margin-top: 26px;
    padding: 10px 0 10px;
}

.t-line {
    position: absolute;
    left: 50%;
    top: 0;
    bottom: 0;
    width: 2px;
    background: #d9d9d9;
    transform: translateX(-50%);
}

/* ✅ 活动点（会移动） */
.t-active-dot {
    position: absolute;
    left: 50%;
    width: 14px;
    height: 14px;
    border-radius: 999px;
    background: #1e64b7;
    transform: translateX(-50%);
    transition: top .25s ease;
    box-shadow: 0 0 0 5px rgba(30, 100, 183, .15);
    z-index: 3;
}

/* 每一行：左右两侧 + 中间 */
.t-row {
    display: grid;
    grid-template-columns: 1fr 80px 1fr;
    align-items: start;
    padding: 22px 0;
}

.t-side {
    min-height: 10px;
}

.t-mid {
    position: relative;
    height: 100%;
    display: grid;
    place-items: start center;
}

.t-dot {
    margin-top: 6px;
    width: 12px;
    height: 12px;
    border-radius: 999px;
    background: #1e64b7;
    border: 3px solid rgba(30, 100, 183, .25);
    box-sizing: content-box;
}

/* year */
.t-year {
    color: #1e64b7;
    font-size: 34px;
    font-weight: 800;
    margin-bottom: 10px;
}

/* card */
.t-card {
    background: #f6f7f9;
    border-radius: 6px;
    padding: 18px 18px;
    color: #777;
    line-height: 2.0;
    max-width: 520px;
    box-shadow: 0 0 0 rgba(0, 0, 0, 0);
    transition: transform .22s ease, box-shadow .22s ease, background-color .22s ease;
}

.t-text {
    font-size: 14px;
}

/* 左右对齐更像截图 */
.t-row.left .t-side:first-child {
    text-align: right;
    padding-right: 22px;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
}

.t-row.right .t-side:last-child {
    text-align: left;
    padding-left: 22px;
}

/* ✅ hover 的“移动动画效果”：卡片轻微横向滑动 + 阴影增强 */
.t-row.left.active .t-card {
    transform: translateX(-10px);
    box-shadow: 0 14px 34px rgba(0, 0, 0, 0.08);
    background: #ffffff;
}

.t-row.right.active .t-card {
    transform: translateX(10px);
    box-shadow: 0 14px 34px rgba(0, 0, 0, 0.08);
    background: #ffffff;
}

/* 其它区块占位 */
.placeholder {
    height: 220px;
    border-radius: 8px;
    border: 1px dashed #d7d7d7;
    background: #fff;
    display: grid;
    place-items: center;
    color: #999;
}

.contact {
    max-width: 860px;
    margin: 0 auto;
    padding: 18px 0 0;
}

.c-item {
    color: #666;
    font-size: 16px;
    line-height: 2.1;
    margin: 10px 0;
}

.c-k {
    color: #333;
    font-weight: 700;
}

/* responsive */
@media (max-width: 980px) {
    .hero {
        height: 260px;
    }

    .quick-grid {
        grid-template-columns: repeat(2, 1fr);
    }

    .adv-grid {
        grid-template-columns: 1fr;
    }

    .t-row {
        grid-template-columns: 1fr;
    }

    .t-line,
    .t-active-dot {
        display: none;
    }

    /* 小屏简化 */
    .t-mid {
        display: none;
    }

    .t-row.left .t-side:first-child,
    .t-row.right .t-side:last-child {
        text-align: left;
        padding: 0;
        align-items: flex-start;
    }

    .t-year {
        font-size: 28px;
    }

    .t-card {
        max-width: 100%;
    }
}
</style>
